import { List, Col, Row, Select } from "antd";
import { EditOutlined, StopOutlined } from "@ant-design/icons";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paginationDefaults } from "../../../utils/properties";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setLoading } from "../../../redux/ducks/Loading";
import OrderApproval from "../../../services/api/OrderApproval";
import { checkRole } from "../../../utils/utilities";

const SalApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const [state, setState] = useState({
    costCentersList: [],
    tableContent: [],
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
    // the approver role can be chosen by a user who is both timesheet_approver and pm/super pm (the System IT always views all suppliers)
    canChooseApproverRole:
      userInfo.roles &&
      checkRole(userInfo.roles, "TIMESHEET_APPROVER") &&
      (checkRole(userInfo.roles, "PM") || checkRole(userInfo.roles, "SUPER_PM")),
    salApproverRole: "TIMESHEET_APPROVER",
  });

  useEffect(() => {
    dataList();
  }, [state.salApproverRole]);

  const dataList = async (page = state.pagination.currentPage) => {
    dispatch(setLoading(true));
    const roleQueryParam = state.canChooseApproverRole ? `&role=${state.salApproverRole}` : "";
    const salApprovalSuppliers = await OrderApproval.salApprovalSuppliers(
      `page=${page - 1}&size=${state.pagination.size}${roleQueryParam}`
    );
    if (!salApprovalSuppliers.error && salApprovalSuppliers.data) {
      salApprovalSuppliers.data.forEach((cc, i) => {
        cc.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        tableContent: get(salApprovalSuppliers, "data", []),
        pagination: {
          currentPage: salApprovalSuppliers.currentPage
            ? salApprovalSuppliers.currentPage + 1
            : paginationDefaults.page,
          size: get(salApprovalSuppliers, "pageSize", paginationDefaults.size),
          totalItems: get(salApprovalSuppliers, "totalItems", paginationDefaults.totalItems),
        },
      }));
    }
    dispatch(setLoading(false));
  };

  return (
    <>
      {state.canChooseApproverRole && (
        <Col lg={7} md={7} xs={24} sm={24}>
          <Row>
            <label className="fw-bold" htmlFor="salApproverRole">
              {t("salApproval.salApproverRole")}
            </label>
          </Row>
          <Row>
            <Select
              id="salApproverRole"
              name="salApproverRole"
              placeholder={t("salApproval.salApproverRole")}
              options={[
                { value: "TIMESHEET_APPROVER", label: t("salApproval.functionManager") },
                { value: "PM", label: t("salApproval.pm") },
              ]}
              onChange={(value) => setState((prevState) => ({ ...prevState, salApproverRole: value }))}
              value={state.salApproverRole}
              className="mb-10 mt-10"
              popupMatchSelectWidth={false}
            />
          </Row>
        </Col>
      )}
      <List
        header={<strong>{t("userSupplier.suppliers")}</strong>}
        bordered
        size="small"
        pagination={{
          size: "small",
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(page);
          },
        }}
        dataSource={state.tableContent}
        renderItem={(item) => (
          <List.Item
            actions={[
              <div
                className="list-actions"
                key={item.id}
                onClick={() =>
                  navigate(`${item.id}`, { state: { name: item.name, approverRole: state.salApproverRole } })
                }
              >
                <EditOutlined className="icon-medium" />
              </div>,
            ]}
          >
            <List.Item.Meta
              title={
                <div>
                  {item.orderBlocked && <StopOutlined className="PFred mr-10" />}
                  {`${item.id} | ${item.name}`}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </>
  );
};

export default SalApproval;
